import { StatelessComponent, ComponentType } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/CreditAccountsDetailsModule/CreditAccountsDetailsModule.css'
import * as tableStyles from 'styles/molecules/tables/Table2.css'
import { CreditAccount } from 'interfaces/credit'
import { TimeframeTyped } from 'interfaces/global'
import { EmptyCardBlock } from 'components/features/pfm/Blocks/Blocks'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import Button from 'components/features/pfm/Button/Button'
import Table2 from 'components/molecules/tables/Table2'
import AccountsDetailsHeader from 'components/molecules/tables/AccountsDetailsHeader'
import CreditAccountsDetailsRow, { CreditAccountsDetailsRowProps } from 'components/molecules/tables/CreditAccountsDetailsRow'
import AccountsDetailsRowMobile, { AccountsDetailsRowMobileOwnProps } from 'components/molecules/tables/AccountsDetailsRowMobile'
import CommonHeaderMobile from 'components/molecules/tables/CommonHeaderMobile'
import { BaseSorting } from 'interfaces/table'
import { Omit } from 'interfaces'

export type CreditAccountsDetailsModuleStateProps = {
  isMobile: boolean
  rows: CreditAccount[]
  showLinkagePlaceholder: boolean
}

export type CreditAccountsDetailsModuleOwnProps = TimeframeTyped

type CreditAccountsDetailsModuleProps = CreditAccountsDetailsModuleStateProps & CreditAccountsDetailsModuleOwnProps
type RowComponentProps = Omit<AccountsDetailsRowMobileOwnProps, 'table'> | Omit<CreditAccountsDetailsRowProps, 'table'>

const getAccountType = ({ category }: CreditAccount) => category.value
const getRowKey = (row: CreditAccount) => `${ row.id }`

const DEFAULT_SORTING: BaseSorting = {
  columnName: 'account_type',
  direction: 'asc',
}

// TODO merge this with AccountsDetailsModule
const CreditAccountsDetailsModule: StatelessComponent<CreditAccountsDetailsModuleProps> = (props) => {
  const { showLinkagePlaceholder, rows, isMobile } = props

  if (showLinkagePlaceholder) {
    return (
      <EmptyCardBlock>
        <section className={ styles.notVerifiedBlock }>
          <div className={ styles.blockText }>
            You have not linked your credit file yet.
          </div>
          <div className={ styles.buttonContainer }>
            <NavigationLink to='credit-linkage'>
              <Button>
                Link your credit file
              </Button>
            </NavigationLink>
          </div>
        </section>
      </EmptyCardBlock>
    )
  }

  const HeaderComponent = isMobile ? CommonHeaderMobile : AccountsDetailsHeader
  const RowComponent =
    (isMobile ? AccountsDetailsRowMobile : CreditAccountsDetailsRow) as ComponentType<RowComponentProps>

  const className = cn(tableStyles.creditAccountDetails, {
    [tableStyles.isMobile]: isMobile,
  })

  const table = (
    <div className={ className }>
      <Table2
        rows={ rows }
        getRowKey={ getRowKey }
        sorting={ DEFAULT_SORTING }
      >
        <Table2.HeadRowMarker>
          <HeaderComponent type='creditscore' />
        </Table2.HeadRowMarker>
        <Table2.Rows>
          <Table2.RowSpan name='account_type' force={ isMobile }>
            { getAccountType }
          </Table2.RowSpan>
          <Table2.RowTemplate>
            {
              (row: CreditAccount) => (
                <RowComponent
                  key={ getRowKey(row) }
                  row={ row }
                  type='creditscore'
                />
              )
            }
          </Table2.RowTemplate>
        </Table2.Rows>
      </Table2>
    </div>
  )

  if (rows.length === 0) {
    return (
      <EmptyCardBlock />
    )
  }

  return table
}

export default CreditAccountsDetailsModule

